import Vue from 'vue';
import  basket from "../components/basket.vue";
import  checkoutsteps  from "../components/checkoutsteps.vue";
import { LoadingElement } from 'fire-vue-core';
import {eventBus} from 'fire-vue-core';
import gql from "fake-tag";

document.addEventListener("DOMContentLoaded", function() {
    initFabricSelection();
});
window.addEventListener("Pageeditor:insert", function() {
    initFabricSelection();
});
window.addEventListener("Pageeditor:change", function() {
    initFabricSelection();
});

function initFabricSelection() {

    if(document.getElementById('sparepartscheckout')) {
        new Vue({
            name: 'SparepartsCheckout',
            el: '#sparepartscheckout',
            data: () => ({
                isLoading: true,
                cartBadgeCount: 0,
            }),
            components: {
                checkoutsteps,
                basket,
                LoadingElement
            },
            mounted () {
                this.getBasketProducts();
                eventBus.$on('CallGetBasketProducts', () =>
                    {
                        this.getBasketProducts();
                    }
                )
            },
            methods: {
                getBasketProducts() {
                    const body = JSON.stringify({
                        query: gql`query {
                            basket {
                                positions {
                                    products {
                                        quantity
                                    }
                                }
                            }
                        }`
                    });

                    fetch(graphqlApi, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': yii.getCsrfToken()
                        },
                        body
                    })
                        .then(res => res.json())
                        .then(res => {
                            let cartBadgeCountTemp = 0;
                            res.data.basket.positions.forEach(function(item){
                                cartBadgeCountTemp = cartBadgeCountTemp + item.products[0].quantity;
                            });
                            this.cartBadgeCount = cartBadgeCountTemp;
                            this.isLoading = false;
                        });

                    console.log('outerThingCalled');
                },
            }
        });
    }
}